import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from './useQueryList'
import { APIErrorResponse, User, UserGroups } from '@/types'

type UseUsersByGroupsParams = {
  groups?: UserGroups[] | string
  enabled?: boolean
}

export const useUsersByGroups = ({
  groups,
  enabled = true,
}: UseUsersByGroupsParams): UseQueryResult<User[], APIErrorResponse> => {
  const groupParam = Array.isArray(groups) ? groups.join(',') : groups

  return useQueryList({
    url: '/users/users/',
    params: groupParam ? { group: groupParam } : undefined,
    options: {
      enabled,
      staleTime: 0,
    },
  })
}
